import BaseApiService from './BaseApiService';

class NewDrugsApiService extends BaseApiService {
    constructor() {
        super('new-drugs');
    }

    buildQueryParams({ range, companies, categories, subcategories, classes, brands, excludeBrands, tags, revenues, curves, revenuefilter, legendSort, cumulativeType, showCumulativeRevenueChart, startSyncView, quarterData, showLoe = false, getFicBicData = false }) {
        const queryParams = {};

        if (range) {
            queryParams.range = range;
        }

        if (revenues) {
            queryParams.revenues = revenues;
        }

        if (companies.length > 0) {
            queryParams.companies = companies.join(',');
        }

        if (categories.length > 0) {
            queryParams.categories = categories.join(',');
        }

        if (subcategories.length > 0) {
            queryParams.subcategories = subcategories.join(',');
        }

        if (classes.length > 0) {
            queryParams.classes = classes.join(',');
        }

        if (brands.length > 0) {
            queryParams.brands = brands.join(',');
        }

        if (excludeBrands.length > 0) {
            queryParams.excludeBrands = excludeBrands.join(',');
        }

        if (tags.length > 0) {
            queryParams.tags = tags.join(',');
        }

        if (revenuefilter) {
            queryParams.revenuefilter = revenuefilter;
        }

        if (curves) {
            queryParams.curves = curves;
        }

        if (legendSort) {
            queryParams.legendSort = legendSort;
        }

        if (cumulativeType) {
            queryParams.cumulativeType = cumulativeType;
        }
        if (showCumulativeRevenueChart) {
            queryParams.showCumulativeRevenueChart = true;
        } else {
            queryParams.showCumulativeRevenueChart = false;
        }

        if (startSyncView) {
            queryParams.startSyncView = true;
        } else {
            queryParams.startSyncView = false;
        }

        queryParams.showLoe = showLoe;

        queryParams.getFicBicData = getFicBicData;

        if (quarterData) {
            queryParams.quarterData = quarterData;
        }

        return queryParams;
    }

    async getAll(data) {
        const params = this.buildQueryParams({ ...data, legendSort: null });
        const response = await this.request({ method: 'get', url: '', params });

        return response || { revenues: [], events: [] };
    }


    async exportChartCsv(data) {
        const params = this.buildQueryParams(data);
        const response = await this.request({ method: 'GET', url: 'export', params }) .then(response => {
            this.forceFileDownload(response, name)

        })
            .catch(() => console.log('error occured'));
    }

    forceFileDownload(response, name){

        const url = window.URL.createObjectURL(new Blob([response]))
        const filename = (name) ? name+'.csv' : 'NewDrugsChart.csv';
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    }

}

export default new NewDrugsApiService();
